import { writable } from 'svelte/store';

import { STORAGE_KEY } from 'src/constants';

const getInitialState = (): Record<string, number> => {
	if (typeof window === 'undefined') {
		return {};
	}

	try {
		const stored = window.localStorage.getItem(STORAGE_KEY);
		return stored ? JSON.parse(stored) : {};
	} catch (error) {
		console.error('Failed to parse experimental feature reminder state from localStorage', error);
		return {};
	}
};

function createReminderStore() {
	const { subscribe, update } = writable<Record<string, number>>(getInitialState());

	if (typeof window !== 'undefined') {
		subscribe((value) => {
			try {
				window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
			} catch (error) {
				console.error('Failed to persist experimental feature reminder state', error);
			}
		});
	}

	return {
		subscribe,
		setReminder: (featureId: string, timestamp: number) => {
			update((current) => ({ ...current, [featureId]: timestamp }));
		},
		clearReminder: (featureId: string) => {
			update((current) => {
				if (!(featureId in current)) {
					return current;
				}
				const { [featureId]: _removed, ...rest } = current;
				return rest;
			});
		},
	};
}

export const experimental_feature_feedback_reminders = createReminderStore();
